/**
 * @file 长图文挂载商品组件
 * @author rongtan@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import openUrl from '@native/open-url';
import filter from '@utils/filter';

export default class mountCard extends Component {
    static template = `
        <div class="mount-card-wrap" on-click="itemClick">
            <template>
                <img class="img" src="{{data.cover.url}}" mode="aspectFill" />
                <div class="text-info">
                    <div class="title ellipsis-2">{{data.title}}</div>
                    <div class="subtitle">
                        <div class="price">
                            <span class="money-symble">￥</span>
                            <span>{{data.price | price}}</span>
                        </div>
                        <div class="buy-btn">购买</div>
                    </div>
                </div>
            </template>
        </div>
    `;
    static filters = {
        price: filter.price
    }
    // 卡片点击
    itemClick() {
        const skuId = this.data.get('data.skuId');
        const path = '/pages/goods-detail/index?pfr=article&skuId=' + skuId;
        openUrl({path});
    }
}
